import { CheckCircleTwoTone, StopTwoTone } from '@ant-design/icons'

const EnabledIndicator: React.VFC<{ enabled?: boolean }> = ({ enabled }) =>
  enabled ? (
    <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 17 }} />
  ) : (
    <StopTwoTone twoToneColor="#c9c9c9" style={{ fontSize: 17 }} rotate={90} />
  )

export default EnabledIndicator
